import { render, staticRenderFns } from "./Apostila.vue?vue&type=template&id=d80e3a10&"
import script from "./Apostila.vue?vue&type=script&lang=js&"
export * from "./Apostila.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports